import {
  ContentCompose,
  DocumentFolderCollection,
  DocumentImage,
  PersonFeatured,
  ThingMap,
  DocumentList,
  ThingTimer,
  ControlDashboard,
  ThingStats,
  PlaceTemple,
} from '@fs/zion-icon'

export const adminPages = [
  {
    title: 'Onboarding Questions',
    description: 'Manage onboarding questions and answer options for the discovery onboarding flow.',
    icon: DocumentList,
    path: '/admin/onboarding-questions',
    permissionType: 'asset',
    permission: 'DiscoveryAssetPermission',
    context: 'DiscoveryAdminAssetContext',
  },
  {
    title: 'Asset Upload',
    description: 'Upload and manage assets on the CDN. Supports image, video, and document uploads.',
    icon: DocumentFolderCollection,
    path: '/admin/asset-upload',
    permissionType: 'asset',
    permission: 'DiscoveryAssetPermission',
    context: 'DiscoveryAdminAssetContext',
  },
  {
    title: 'Famous Relatives',
    description: 'Search and manage data about famous relatives connections and relationship data.',
    icon: PersonFeatured,
    path: '/admin/famous-relatives',
    permissionType: 'manageContent',
    permission: 'DiscoveryFamousManageContentPermission',
    context: 'DiscoveryManageContentContext',
    subnav: [
      {
        title: 'Review Famous Suggestions',
        path: '/admin/famous-relatives/FamousRelativesSuggestions',
      },
      {
        title: 'Add Famous Tree Person',
        path: '/admin/famous-relatives/add-tree-person',
      },
      {
        title: 'Manage Famous Ancestors',
        path: '/admin/famous-relatives/management-famous-ancestors',
      },
    ],
  },
  {
    title: 'Time Machine',
    description: 'Create, update, and delete timeline events.',
    icon: ThingTimer,
    path: '/admin/time-machine',
    permissionType: 'timeMachineContent',
    permission: 'DiscoveryTimeMachineManageContentPermission',
    context: 'DiscoveryManageContentContext',
  },
  {
    title: 'QA Dashboard (Test)',
    description:
      'Preview Discovery QA test runs — pass rates, run history, and per-case results — from the Quality Dashboard service.',
    icon: ControlDashboard,
    path: '/admin/qadashboardtest',
    permissionType: 'adminUi',
    permission: 'DiscoveryAdminUIPermission',
    context: 'DiscoveryAdminUIContext',
  },
  {
    title: 'Labs Feedback Report',
    description:
      'Beta feedback analysis — scores, themes, segments and field-test results across Discovery Labs experiences.',
    icon: ThingStats,
    path: '/admin/labs-feedback',
    permissionType: 'adminUi',
    permission: 'ReadUserFeedbackPermission',
    context: 'DiscoveryUserFeedbackContext',
  },
  {
    title: 'AI Generated Content',
    description:
      'Review AI-generated content and configure the discovery-ai service — review queues, approved applications, and reviewer prompts.',
    icon: ContentCompose,
    path: '/admin/ai-efforts',
    permissionType: 'aiEfforts',
    subnav: [
      {
        title: 'Human Review AI Content',
        description:
          'Human review queue for content generated by the discovery-ai service — read the AI reviewer score, edit the generated text, and approve it.',
        path: '/admin/ai-content-review',
        permissionType: 'contentReview',
        permission: 'DiscoveryContentReviewPermission',
        context: 'DiscoveryManageContentContext',
      },
      {
        title: 'Approved Applications',
        description:
          'Approve the applications discovery-ai will generate content for, and enable or disable them. Application keys are frozen once created.',
        path: '/admin/ai-applications',
        permissionType: 'databaseAdmin',
        permission: 'DiscoveryDatabasePermission',
        context: 'DiscoveryAdminDatabaseContext',
      },
      {
        title: 'Review AI Prompts',
        description:
          'Write the prompts the AI reviewer judges generated content against, per application and content kind.',
        path: '/admin/ai-review-prompts',
        permissionType: 'databaseAdmin',
        permission: 'DiscoveryDatabasePermission',
        context: 'DiscoveryAdminDatabaseContext',
      },
      {
        title: 'Content Review (MyYear)',
        description:
          'Human moderation queue for AI-generated MyYear facts and quizzes — approve or delete content flagged by the AI content reviewer.',
        path: '/admin/content-review',
        permissionType: 'adminUi',
        permission: 'DiscoveryAdminUIPermission',
        context: 'DiscoveryAdminUIContext',
      },
      {
        title: 'Review Content (Recipes)',
        description: 'Review and manage AI-generated recipe content by country.',
        path: '/admin/reviewcontent',
        permissionType: 'asset',
        permission: 'DiscoveryAssetPermission',
        context: 'DiscoveryAdminAssetContext',
      },
    ],
  },
  {
    title: 'Temples',
    description: 'View, add, edit, and delete the temple data behind the temple experience.',
    icon: PlaceTemple,
    path: '/admin/temples',
    permissionType: 'databaseAdmin',
    permission: 'DiscoveryDatabasePermission',
    context: 'DiscoveryAdminDatabaseContext',
  },
  {
    title: 'Heritage Portraits',
    description:
      'Manage the shared base prompt, the Heritage and Artistic Style catalogues, and test-generate Heritage Portraits.',
    icon: DocumentImage,
    path: '/admin/heritage-portraits',
    permissionType: 'asset',
    permission: 'DiscoveryAssetPermission',
    context: 'DiscoveryAdminAssetContext',
  },
]

export const contentReviewPages = [
  {
    title: 'Human Review AI Content',
    description:
      'Human review queue for content generated by the discovery-ai service — read the AI reviewer score, edit the generated text, and approve it.',
    icon: ContentCompose,
    path: '/support/ai-content-review',
    permission: 'DiscoveryContentReviewPermission',
    context: 'DiscoveryManageContentContext',
  },
]

export const supportPages = [
  {
    title: 'Center Support',
    description: 'Manage discovery centers, locations, and coordinates. View and edit center information.',
    icon: ThingMap,
    path: '/center/support',
    permission: 'DiscoveryCenterSupportPermission',
    context: 'DiscoveryCenterContext',
  },
]
